import { useCallback } from 'react'
import moment from 'moment'

import { useSpreadsheet } from 'hooks/useSpreadsheet'
import { DATE_FILE_FORMAT } from 'utils/constants'

export const useExportScholarships = (programs, search) => {
  const { exportFile } = useSpreadsheet()

  const exportToSpreadsheet = useCallback(() => {
    if (search === 'organizations') {
      //Export Organization Name, isNspaMember
      const data = [
        [
          'Organization Name',
          'Is NSPA Member',
          'Organization Type',
          'Organization Category',
          'State',
          'Phone Number',
          'Number of Programs',
          'Program Staff Count',
          'Scholarship Program Established',
          'Annual Program Award',
          'Annual Academic Award',
          'Annual Awards Given',
          'Award Range',
          'Renewable',
          'Need Based',
          'Merit Based',
          'Seeking Degree',
        ],
        ...programs?.map((program) => [
          program.programOrganizationName,
          program.isNspaMember ? 'Yes' : 'No',
          program.orgType,
          program.orgCategory,
          program.stateCategory,
          program.phoneNumberCategory,
          program.numPrograms,
          program.staffCount,
          program.yearFirstScholarship,
          program.totalAwardAmount,
          program.totalDollarAmount,
          program.totalNumberStudents,
          program.scholarshipMaximumAwardOrganization &&
          program.scholarshipMinimumAwardOrganization
            ? `${program.scholarshipMinimumAwardOrganization} - ${program.scholarshipMaximumAwardOrganization}`
            : `${
                program.scholarshipMinimumAwardOrganization ||
                program.scholarshipMaximumAwardOrganization
              }`,
          program.renewable,
          program.meritBasedOrganization,
          program.needBasedOrganization,
          program.degreeBeingSought,
        ]),
      ]
      if (data.length > 1) {
        const fileName = `Organizations-${moment().format(DATE_FILE_FORMAT)}`
        exportFile(data, fileName)
      }
    } else {
      const data = [
        [
          'Program Name',
          'Organization Name',
          'Blurb',
          'Eligibility Criteria',
          'Open Date',
          'Close Date',
          'Award Amount',
        ],
        ...programs?.map((program) => [
          program.programName,
          program.programOrganizationName,
          program.blurb,
          program.eligibilityCriteriaDescription,
          program.openDate,
          program.closeDate,
          program.scholarshipMaximumAward,
        ]),
      ]
      if (data.length > 1) {
        const fileName = `Scholarships-${moment().format(DATE_FILE_FORMAT)}`
        exportFile(data, fileName)
      }
    }
  }, [programs, exportFile])

  return {
    exportToSpreadsheet,
  }
}
